// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.12.4
//   protoc               unknown
// source: qonto/registration/organizations/firstparty/v1/list_organizations.proto

/* oxlint-disable */
import { ApiOrganization } from "./organization";

/** Request message for listing organizations */
export interface ApiListOrganizationsRequest {
  /**
   * When present, filters Embed partner organizations by contract signed status.
   * The value is not checked, only the presence of the parameter matters.
   */
  readonly embedContractSigned?: string | null | undefined;
}

/** Response message for listing organizations */
export interface ApiListOrganizationsResponse {
  /** List of organizations */
  readonly organizations: readonly ApiOrganization[];
}

export const ApiListOrganizationsRequest: MessageFns<ApiListOrganizationsRequest> = {
  fromJSON(object: any): ApiListOrganizationsRequest {
    return {
      embedContractSigned: isSet(object.embed_contract_signed) ? globalThis.String(object.embed_contract_signed) : null,
    };
  },

  toJSON(message: ApiListOrganizationsRequest): unknown {
    const obj: any = {};
    if (message.embedContractSigned !== undefined && message.embedContractSigned !== null) {
      obj.embed_contract_signed = message.embedContractSigned;
    }
    return obj;
  },
};

export const ApiListOrganizationsResponse: MessageFns<ApiListOrganizationsResponse> = {
  fromJSON(object: any): ApiListOrganizationsResponse {
    return {
      organizations: globalThis.Array.isArray(object?.organizations)
        ? object.organizations.map((e: any) => ApiOrganization.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ApiListOrganizationsResponse): unknown {
    const obj: any = {};
    if (message.organizations?.length) {
      obj.organizations = message.organizations.map((e) => ApiOrganization.toJSON(e));
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
